import HomeAddRepoButton from "@chariz/components/buy/HomeAddRepoButton";
import { render } from "react-dom";

$(() => {
	if ($("html")
		.hasClass("os-ios")) {
		const addRepoContainer = $(".home-add-repo-container");
		if (addRepoContainer.length > 0) {
			render(<HomeAddRepoButton />, addRepoContainer[0]!);
		}
	}
});
